<template>
  <div class="slider"
  :class="{'slider--dragging' : draggingActive}">
    <vueSlider
      v-model="value"
      :data="data"
      :height="1"
      @change="changeValue"
      @drag-start="draggingActive = true"
      @drag-end="draggingActive =  false"
      :dotSize="30"
      :contained="true"
      :duration=".3"
      tooltip="always"
      :tooltipFormatter="tooltipFormatter"
    >
    </vueSlider>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';


export default {
  name: 'slider',
  components: { VueSlider },
  props: ['values', 'current', 'currentSetting', 'currentMode'],
  data: () => ({
    value: 0,
    data: [],
    setting: false,
    draggingActive: false,
  }),
  computed: {
    tooltipFormatter() {
      if (!this.currentMode) return '{value}';
      if (this.currentMode === 's') return '{value}s';
      return (val) => {
        const pad = (num, size) => (`000${num}`).slice(size * -1);
        const time = parseFloat(val).toFixed(3);
        const minutes = Math.floor(time / 60) % 60;
        const seconds = Math.floor(time - minutes * 60);
        return `${pad(minutes, 1)}:${pad(seconds, 2)}m`;
      };
    },
  },
  created() {
    this.value = this.current;
    this.data = this.values;
    this.setting = this.currentSetting;
  },
  methods: {
    changeValue() {
      const timer = {
        key: this.setting,
        value: this.value,
      };
      this.$emit('changeValue', timer);
    },
  },
  watch: {
    values() {
      this.data = this.values;
    },
    current() {
      this.value = this.current;
    },
    currentSetting() {
      this.setting = this.currentSetting;
    },
  },
};
</script>

<style lang="stylus">
@import '~styles/slider'

.slider
  width 95%
  max-width 600px
  margin -89px auto
</style>
